import { render, staticRenderFns } from "./resend-confirmation.vue?vue&type=template&id=4ce25fff&"
import script from "./resend-confirmation.vue?vue&type=script&lang=js&"
export * from "./resend-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./resend-confirmation.vue?vue&type=style&index=0&id=4ce25fff&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports